import { Maybe } from 'maybeasy';
import { observer } from 'mobx-react';
import { FormTemplate } from '../../../../../../../Resource/FormTemplates/Types';
import { T } from '../../../../../../../Translations';
import CollaboratorsIcon from '../../../../../../Cutesies/CollaboratorsIcon';
import Collaborators from './Collaborators';

interface Props {
  template: Maybe<FormTemplate>;
}

function ShareSection({ template }: Props) {
  return (
    <div className="bg-white border-solid border-1 border-gray-200 rounded max-w-md">
      <div className="m-8">
        <div className="pb-6">
          <CollaboratorsIcon />
        </div>
        <h3 className="pb-6 text-xl font-semibold">
          <T kind="Share with <text>collaborators</text>" text={(content) => <u>{content}</u>} />
        </h3>
        <div className="font-sans text-base pb-6">
          <T
            kind="Share access to your Learning Collection with <text>authorized users.</text>"
            text={(content) => <div className="text-cyan-700 font-semibold">{content}</div>}
          />
        </div>
        <Collaborators template={template} />
      </div>
    </div>
  );
}

export default observer(ShareSection);
